import React from "react";

/** Global email styling overrides */
export interface EmailStyleSettings {
  /** Outer background color (outside content area) */
  backgroundColor: string;

  /** Content max width in pixels */
  maxWidth: number;
  /** Container top padding in px */
  containerPaddingTop: number;
  /** Container bottom padding in px */
  containerPaddingBottom: number;
  /** Container left padding in px */
  containerPaddingLeft: number;
  /** Container right padding in px */
  containerPaddingRight: number;
  /** Inner container background color (distinct from outer body bg) */
  containerBackgroundColor: string;

  /** Default font family */
  fontFamily: string;
  /** Default font size (CSS value, e.g. "14px") */
  fontSize: string;
  /** Default text color */
  textColor: string;

  /** Default link color */
  linkColor: string;

  /* ── Per-element style overrides ──────────────────────────── */

  /** Heading text color */
  headingColor: string;

  /** Image corner radius in px */
  imageBorderRadius: number;

  /** Button background color */
  buttonBackgroundColor: string;
  /** Button text color */
  buttonTextColor: string;
  /** Button corner radius in px */
  buttonBorderRadius: number;
  /** Button horizontal padding in px */
  buttonPaddingX: number;
  /** Button vertical padding in px */
  buttonPaddingY: number;
  /** Button border width in px */
  buttonBorderWidth: number;
  /** Button border style */
  buttonBorderStyle: string;
  /** Button border color */
  buttonBorderColor: string;
}

export const DEFAULT_STYLE_SETTINGS: EmailStyleSettings = {
  backgroundColor: "transparent",
  maxWidth: 600,
  containerPaddingTop: 20,
  containerPaddingBottom: 0,
  containerPaddingLeft: 15,
  containerPaddingRight: 15,
  containerBackgroundColor: "#ffffff",
  fontFamily: "'Arial', 'Helvetica Neue', 'Helvetica', sans-serif",
  fontSize: "14px",
  textColor: "#1a1a1a",
  linkColor: "#006bb5",

  headingColor: "#1a1a1a",
  imageBorderRadius: 4,
  buttonBackgroundColor: "#006bb5",
  buttonTextColor: "#ffffff",
  buttonBorderRadius: 8,
  buttonPaddingX: 24,
  buttonPaddingY: 12,
  buttonBorderWidth: 0,
  buttonBorderStyle: "solid",
  buttonBorderColor: "#000000",
};

/** Style objects shared between the WYSIWYG canvas and the email converter. */
export function getBodyStyles(
  settings: EmailStyleSettings,
): React.CSSProperties {
  return {
    backgroundColor: settings.backgroundColor,
    fontFamily: settings.fontFamily,
    fontSize: settings.fontSize,
    margin: "0",
    padding: "0",
  };
}

export function getContainerStyles(
  settings: EmailStyleSettings,
): React.CSSProperties {
  return {
    maxWidth: `${settings.maxWidth}px`,
    margin: "0 auto",
    paddingTop: `${settings.containerPaddingTop}px`,
    paddingBottom: `${settings.containerPaddingBottom}px`,
    paddingLeft: `${settings.containerPaddingLeft}px`,
    paddingRight: `${settings.containerPaddingRight}px`,
    backgroundColor: settings.containerBackgroundColor,
    color: settings.textColor,
    position: "relative",
  };
}
